// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getConfiguration as getConfigurationAPI,
    updateConfiguration as updateConfigurationAPI,
} from '../../helpers/';

import { configurationsApiResponseError, configurationsApiResponseSuccess } from './actions';
import { ConfigurationsActionTypes } from './constants';


/**
 * Get configuration
 * @param {*} payload - username and password
 */
function* getConfiguration({ payload: { configurationId } }) {
    try {
        const response = yield call(getConfigurationAPI, configurationId);
        const configuration = response.data.data;
        yield put(configurationsApiResponseSuccess(ConfigurationsActionTypes.GET_CONFIGURATION, configuration));
    } catch (error) {
        yield put(configurationsApiResponseError(ConfigurationsActionTypes.GET_CONFIGURATION, error));
    }
}

function* updateConfiguration({ payload: configuration }) {
    try {
        const response = yield call(updateConfigurationAPI, { ...configuration })
        const configurationItem = response.data.data
        yield put(configurationsApiResponseSuccess(ConfigurationsActionTypes.UPDATE_CONFIGURATION, configurationItem))
    } catch (error) {
        yield put(configurationsApiResponseError(ConfigurationsActionTypes.UPDATE_CONFIGURATION, error))
    }
}

export function* watchGetConfiguration(): any {
    yield takeEvery(ConfigurationsActionTypes.GET_CONFIGURATION, getConfiguration);
}

export function* watchUpdateConfiguration(): any {
    yield takeEvery(ConfigurationsActionTypes.UPDATE_CONFIGURATION, updateConfiguration)
}

function* configurationsSaga(): any {
    yield all([
        fork(watchGetConfiguration),
        fork(watchUpdateConfiguration)
    ]);
}

export default configurationsSaga;
